import { BOOKING_STATUS } from "@fysaro/shared";
import { z } from "zod";

export const bookingFormSchema = z.object({
  clinicId: z.string().uuid().optional(),
  // CREATE: obligatorio
  // EDIT: oculto, no se enví­a
  patientId: z.string().uuid().optional().nullable(),

  // CREATE: obligatorio
  // EDIT: editable
  professionalId: z.string().uuid(),

  // CREATE: obligatorio
  // EDIT: editable
  serviceId: z.string().uuid(),

  // Ambos modos
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  time: z.string().regex(/^\d{2}:\d{2}$/),

  // Ambos modos
  duration: z.number(),

  // Ambos modos
  notes: z.string().max(500).optional(),

  // CREATE: visible
  // EDIT: oculto
  notify: z.boolean().optional(),

  // EDIT: visible
  // CREATE: oculto
  status: z.enum(BOOKING_STATUS).optional(),
  
  // ðŸ›¡ï¸ Añadimos los campos del triaje clí­nico como opcionales / nulables
  patientRawText: z.string().optional().nullable(),
  aiSummary: z.string().optional().nullable(),
  aiServiceReason: z.string().optional().nullable(), // Mapea a 'explanation'
  aiEstimatedPain: z.number().int().min(1).max(10).optional().nullable(),
  aiRedFlags: z.array(z.string()).optional().nullable(),
});

export const updateBookingSchema = bookingFormSchema
  .partial()
  .superRefine((data, ctx) => {
    const hasDate = data.date !== undefined;
    const hasTime = data.time !== undefined;

    if (hasDate !== hasTime) {
      ctx.addIssue({
        code: "custom",
        path: hasDate ? ["time"] : ["date"],
        message: "La fecha y la hora deben actualizarse juntas",
      });
    }
  });


// export const createBookingSchema = z.object({
//   patientId: z.string().uuid(),
//   professionalId: z.string().uuid(),
//   serviceId: z.string().uuid(),
//   start: z.string(),
//   date: z.string(),
//   time: z.string(),
//   duration: z.number().optional(),
//   notes: z.string().max(500).optional(),
//   notify: z.boolean().default(false)
// });

// // En tu archivo de schemas
// export const updateBookingSchema = z.object({
//   status: z.enum(BOOKING_STATUS).optional(),
//   notes: z.string().max(500).optional().nullable(),
//   // Los hacemos opcionales para que ChangeStatus no se queje
//   start: z.string().optional(),
//   date: z.string().optional(),
//   time: z.string().optional(),
//   duration: z.number().optional(),
// }).refine((data) => {
//   // Opcional: Validación extra si quieres que si viene 'date' también venga 'time'
//   if ((data.date && !data.time) || (!data.date && data.time)) return false;
//   return true;
// }, { message: "Date and Time must be provided together" });

